import type { Project } from '@/types'

/**
 * N = PROJECTS.length = 8 (§3.2). `accent` is the solid fill behind a poster while
 * it loads; `focus` biases the crop, since the posters are portraits and the panels
 * are near-square on desktop.
 */
export const PROJECTS: Project[] = [
    {
        id: 'northbank',
        name: 'Northbank',
        description: 'Wayfinding across nine transit stations',
        poster: '/images/northbank.jpg',
        accent: '#1b3a5b',
        year: '2024',
        discipline: 'Wayfinding',
        focus: '50% 34%'
    },
    {
        id: 'solvent',
        name: 'Solvent',
        description: 'Product site for an industrial coatings lab',
        poster: '/images/solvent.jpg',
        accent: '#5b4a2b',
        year: '2023',
        discipline: 'Interface',
        focus: '50% 32%'
    },
    {
        id: 'halcyon',
        name: 'Halcyon',
        description: 'A type family in five weights and two widths',
        poster: '/images/halcyon.jpg',
        accent: '#123a8a',
        year: '2023',
        discipline: 'Typeface',
        focus: '50% 30%'
    },
    {
        id: 'kessler',
        name: 'Kessler',
        description: 'Identity and packaging for a cold-brew roaster',
        poster: '/images/kessler.jpg',
        accent: '#4a2418',
        year: '2022',
        discipline: 'Identity',
        focus: '50% 34%'
    },
    {
        id: 'marlow',
        name: 'Marlow',
        description: 'Art direction for a photographic monograph',
        poster: '/images/marlow.jpg',
        accent: '#3d3a2c',
        year: '2022',
        discipline: 'Editorial',
        focus: '50% 40%'
    },
    {
        id: 'meridian',
        name: 'Meridian',
        description: 'Identity for a celestial navigation app',
        poster: '/images/meridian.jpg',
        accent: '#20303f',
        year: '2021',
        discipline: 'Identity',
        focus: '50% 38%'
    },
    {
        id: 'aster',
        name: 'Aster',
        description: 'Brand system for a botanical skincare line',
        poster: '/images/aster.jpg',
        accent: '#2c3a2c',
        year: '2020',
        discipline: 'Packaging',
        focus: '50% 36%'
    },
    {
        id: 'verso',
        name: 'Verso',
        description: 'A reading app that respects the margin',
        poster: '/images/verso.jpg',
        accent: '#2c2c30',
        year: '2019',
        discipline: 'Interface',
        focus: '50% 30%'
    }
]
